import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import FeaturesPage from './pages/FeaturesPage';
import ScreenshotsPage from './pages/ScreenshotsPage';
import PomodoroPage from './pages/PomodoroPage';
import CountdownPage from './pages/CountdownPage';
import DeveloperPage from './pages/DeveloperPage';
import LegalPage from './pages/LegalPage'; // Imported
import ScrollToTop from './components/ScrollToTop';
import FloatingMenu from './components/FloatingMenu';
import './index.css';

function App() {
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/screenshots" element={<ScreenshotsPage />} />
          <Route path="/pomodoro" element={<PomodoroPage />} />
          <Route path="/countdown" element={<CountdownPage />} />
          <Route path="/developer" element={<DeveloperPage />} />
          <Route path="/legal" element={<LegalPage />} /> {/* Added Route */}
        </Routes>
        <FloatingMenu theme={theme} toggleTheme={toggleTheme} />
      </div>
    </Router>
  );
}

export default App;
